var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ContentModule_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import TargetStrategy from '@slickdeals/durango/dist/javascript/strategies/visibility/targetStrategy';
import TriggerStrategy from '@slickdeals/durango/dist/javascript/strategies/visibility/triggerStrategy';
import BlueprintComponent from '../core/blueprintComponent';
import IconStrategy from '../strategies/indicator/iconStrategy';
import { Animations } from '../utilities/animation';
import VisibilityToggle, { ClassNames as VisibilityToggleClassNames } from './visibilityToggle';
import './button';
import './icon';
import './dynamicLink';
import '../../scss/components/contentModule.scss';
/** The name of the module */
export const name = 'ContentModule';
/** The CSS selector for use in selector lookups in scripts */
export const JS_SELECTOR = 'js-contentModule';
/** The base CSS classname for the main element controlled by this module */
export const CSS_CLASSNAME = 'bp-c-contentModule';
export const ClassNames = {
    Default: 'bp-c-contentModule',
    Javascript: 'js-contentModule',
    Trigger: 'js-contentModule_trigger',
    Target: 'js-contentModule_target',
};
let ContentModule = ContentModule_1 = class ContentModule extends BlueprintComponent {
    /**
     * Create a ContentModule UI component
     *
     * @param visibilityToggle
     * @param options Data and options to initialize the component with
     */
    constructor(options) {
        super(name, options);
    }
    /**
     * Create a new instance of this object
     *
     * @param options Data and options to initialize component with
     */
    static create(options) {
        return new ContentModule_1(options);
    }
    /**
       * Performs any necessary initialization for the component
       */
    async init() {
        super.init();
        this.element = await BlueprintComponent.loadElement(name, this.options);
        // Creates the visibility toggle instance for this module
        this.initVisibilityToggle();
    }
    /**
     * Creates the visibility toggle and all of its dependencies
     */
    initVisibilityToggle() {
        this.triggerElement = this.element.querySelector(`.${ClassNames.Trigger}`);
        this.targetElements = Array.from(this.element.querySelectorAll(`.${ClassNames.Target}`));
        const triggerStrategy = new TriggerStrategy({
            classNames: {
                base: VisibilityToggleClassNames.Default,
                visible: VisibilityToggleClassNames.Visible,
            },
            element: this.triggerElement,
        });
        const targetStrategy = new TargetStrategy({
            classNames: {
                base: VisibilityToggleClassNames.Default,
                visible: VisibilityToggleClassNames.Visible,
            },
            elements: this.targetElements,
        });
        const indicatorContainer = this.element.querySelector(`.${VisibilityToggleClassNames.Indicator}`);
        // Creates the indicator to be used by visibility toggle
        const indicatorStrategy = new IconStrategy({
            element: indicatorContainer,
            inactiveIconName: 'arrowDown--xsmall',
            animation: Animations.Flip,
            defaultState: false,
        });
        this.visibilityToggle = new VisibilityToggle({
            triggerStrategy,
            targetStrategy,
            indicatorStrategy,
        });
    }
};
ContentModule = ContentModule_1 = __decorate([
    injectable(name)
], ContentModule);
export default ContentModule;
// Create ContentModule components in the hydration queue
BlueprintComponent.instantiate(name);
